module.exports = __webpack_public_path__ + "img/thex-core.d02baa90.png";